import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.TRANSACTION_MENU;

export const TransactionMenuLinks: Array<LinkItemProps> = [
  {
    name: 'Consultation transaction valide',
    link: URL.VALID_TRANSACTION_CONSULTING,
    level: 3,
  },
  {
    name: 'Statut transaction visa',
    link: URL.VISA_TRANSACTION_STATUS,
    level: 3,
  },
  {
    name: 'Historique transactions visa',
    link: URL.VISA_TRANSACTION_HISTORY,
    level: 3,
  },
  {
    name: 'Résumé sorties',
    link: URL.OUTGOING_SUMMARY,
    level: 3,
  },
  {
    name: 'Résumé entrées',
    link: URL.INCOMING_SUMMARY,
    level: 3,
  },
  
];


